export default __webpack_public_path__ + "86c8a7d98421c6d40f91729259201c11.png";